import { Component, output } from '@angular/core';
import { ICheckmark } from '../../icons/i-checkmark/i-checkmark';
import { ICross } from '../../icons/i-cross/i-cross';

@Component({
  selector: 'rid-assessment-toast',
  imports: [ICheckmark, ICross],
  templateUrl: './rid-assessment-toast.html',
  host: {
    class: 'block absolute -right-12',
    'animate.enter': 'anim-slide-from-right',
    'animate.leave': 'anim-slide-to-right',
  },
})
export class RidAssessmentToast {
  assessed = output<'CORRECT' | 'INCORRECT'>();
}
